import * as z from "zod"

import { safelyExtractEnvVar } from "@repo/utils"

const configSchema = z.object({
  appName: z.string(),
})

export const config = configSchema.parse({
  appName: safelyExtractEnvVar(["VITE_APP_NAME"], "Parcel Partner"),
})

export const authEnvSchema = z.object({
  betterAuthSecret: z.string().min(32),
  baseUrl: z.url(),
  googleClientId: z.string().optional(),
  googleClientSecret: z.string().optional(),
})

export type AuthEnv = z.infer<typeof authEnvSchema>

export function getAuthEnv(): AuthEnv {
  return authEnvSchema.parse({
    betterAuthSecret: safelyExtractEnvVar(["BETTER_AUTH_SECRET"]),
    baseUrl: safelyExtractEnvVar(["BETTER_AUTH_URL", "VITE_BASE_URL"]),
    googleClientId: safelyExtractEnvVar(["GOOGLE_CLIENT_ID"]),
    googleClientSecret: safelyExtractEnvVar(["GOOGLE_CLIENT_SECRET"]),
  })
}
